import { render, staticRenderFns } from "./index.vue?vue&type=template&id=469e7c67&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/app/components/base/Link.vue').default,BaseIcon: require('/app/components/base/Icon.vue').default,BaseCollapseTransition: require('/app/components/base/CollapseTransition.vue').default,BaseToggle: require('/app/components/base/Toggle.vue').default,AppUSP: require('/app/components/app/USP.vue').default})
